import {
  Component,
  ChangeDetectionStrategy,
  input,
  output,
} from '@angular/core';
import { MatMiniFabButton } from '@angular/material/button';
import { MatIcon } from '@angular/material/icon';

@Component({
  selector: 'app-mat-fab-button',
  imports: [MatMiniFabButton, MatIcon],
  templateUrl: './mat-fab-button.component.html',
  styleUrl: './mat-fab-button.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class MatFabButtonComponent {
  /** ID for the button element (optional) */
  buttonId = input<string | undefined>(undefined);

  /** The visual style of the button (optional, default: 'primary') */
  buttonStyle = input<'primary' | 'accent' | 'warn'>('primary');

  /** The HTML button type attribute (optional, default: 'button') */
  buttonType = input<'button' | 'submit' | 'reset'>('button');

  /** Whether the button is disabled (optional, default: false) */
  isDisabled = input<boolean>(false);

  /** Material icon name (required) */
  iconName = input.required<string>();

  /** Aria label & title (required) */
  ariaLabel = input.required<string>();

  /** Event emitted when the button is clicked */
  buttonClicked = output<void>();

  /** Whether the icon should animate */
  animateSpinner = input<boolean>(false);

  /**
   * Handles the button click event and emits the buttonClicked event
   */
  clickButton = (): void => {
    this.buttonClicked.emit();
  };
}
